type Rotation = 0 | 90 | 180 | 270
type RotationDelta = 90 | -90

export type UpdatePageRotationsBatch = {
  pageNumbers: number[]
  rotation: Rotation
}

export function updatedDocumentPageRotations({
  pageCount,
  pageRotations,
  delta
}: {
  pageCount?: number
  pageRotations?: Record<string, number>
  delta: RotationDelta
}): UpdatePageRotationsBatch[] {
  if (!pageCount || pageCount <= 0) return []

  const grouped = new Map<Rotation, number[]>()

  for (let pageNumber = 1; pageNumber <= pageCount; pageNumber++) {
    const current = pageRotations?.[pageNumber] ?? pageRotations?.[String(pageNumber)] ?? 0
    const next = normalizeRotation(current + delta)
    const group = grouped.get(next) ?? []
    group.push(pageNumber)
    grouped.set(next, group)
  }

  return [0, 90, 180, 270].flatMap((rotation) => {
    const pageNumbers = grouped.get(rotation as Rotation)
    if (!pageNumbers || pageNumbers.length == 0) return []
    return [{ pageNumbers, rotation: rotation as Rotation }]
  })
}

function normalizeRotation(rotation: number): Rotation {
  return ((rotation % 360) + 360) % 360 as Rotation
}
